function Sliders() {
    this.build();
}

Sliders.prototype.build = function () {
    const sliderContainer = document.querySelector(".swiper-testimonials");
    const slider = document.querySelector(".swiper");
    if( !sliderContainer ){
        return;
    }
    const prev = sliderContainer.querySelector(".prev");
    const next = sliderContainer.querySelector(".next");
    const swiper = new Swiper(slider, {
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: sliderContainer.dataset.spaceBetween ? sliderContainer.dataset.spaceBetween : "2%",
        speed: 500,
        touchEventsTarget: "container",
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true
        },
        navigation: {
            prevEl: prev,
            nextEl: next,
        },
        breakpoints: {
            768: {
                slidesPerView: sliderContainer.dataset.slidesPerView ? sliderContainer.dataset.slidesPerView : 1,
            }
        },
    });
};


